export default __webpack_public_path__ + "static/media/encircledAdd.961bf73a.svg";